import { render, staticRenderFns } from "./help-panel.vue?vue&type=template&id=3bdd7f92&scoped=true"
import script from "./help-panel.vue?vue&type=script&lang=js"
export * from "./help-panel.vue?vue&type=script&lang=js"
import style0 from "./help-panel.vue?vue&type=style&index=0&id=3bdd7f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdd7f92",
  null
  
)

export default component.exports